type ArtistSeoTextValue = string | number | null | undefined;

export function cleanArtistSeoText(value?: ArtistSeoTextValue): string {
  return value == null ? '' : String(value).trim();
}

export function uniqueArtistSeoTexts(values: ArtistSeoTextValue[]): string[] {
  return [...new Set(values.map(cleanArtistSeoText).filter(Boolean))];
}

export function buildArtistSearchName(
  primaryName?: ArtistSeoTextValue,
  secondaryName?: ArtistSeoTextValue,
  fallbackName?: ArtistSeoTextValue
): string {
  const names = uniqueArtistSeoTexts([primaryName ?? '', secondaryName ?? '']);
  if (names.length > 0) return names.join(' ');
  return cleanArtistSeoText(fallbackName);
}

export function buildArtistPageTitle(searchName: string): string {
  return searchName || 'Architrave';
}
